import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { FormsModule } from "@angular/forms";
import { DevModeChooserService } from '../../services/dev-mode-chooser.service';
import { MerchantService, TestMidCondition } from '../../services/merchant.service';

@Component({
    selector: 'odin-dev-mode-chooser',
    imports: [MatSlideToggle, FormsModule],
    templateUrl: './dev-mode-chooser.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './dev-mode-chooser.component.css',
})
export class DevModeChooserComponent {
    constructor(
        private merchantService: MerchantService,
        private devModeChooserService: DevModeChooserService
    ) { }

    public onToggleChange(toggle: MatSlideToggle) {
        this.devModeChooserService.prodModeEnabled = toggle.checked;
    }

    getCurrentState(): boolean {
        return this.devModeChooserService.prodModeEnabled;
    }

    getShouldRender(): boolean {
        return this.merchantService.getTestMidCondition() === TestMidCondition.Test;
    }
}
